module.exports = __webpack_public_path__ + "img/dabc0ec.png";